<template>
  <v-app>
    <br><br><br><br><br>
    <router-link to="/index"><img src="@/assets/img/logo.png"  style="width: 400px ;"></router-link>
    <v-card style="width: 400px ;" elevation="3">
      <v-card-text>
        <v-select
          v-model="nn"
          :items="roles"
          item-text="RoleName"
          item-value="AD_Role_ID"
          label="Role"
          persistent-hint
          return-object
          outlined
          dense
          @change="selectOrg()"
        ></v-select>
        <v-combobox
          label="Client "
          :items="role"
          dense
          outlined
          @change="selectOrg()"
        ></v-combobox>
        <v-combobox
          label="Organization "
          :items="role"
          dense
          outlined
          @change="selectOrg()"
        ></v-combobox>
        <v-combobox
          label="Warehouse "
          :items="role"
          dense
          outlined
          @change="selectOrg()"
        ></v-combobox>
        <div align="center">
          <v-btn class="btn btn-primary ">Login</v-btn>
        </div>

      </v-card-text>
    </v-card>
  </v-app>
</template>

<script>
    import {getOrg} from "../service/CallWebService";

    export default {
        name: "Login1",
      props: ['roles'],
      data()
      {
        return{
          role: ["High","Low","Medium","Minor","Urgent"],nn:""
        }
      },
      methods:
        {
          selectOrg(role)
          {
            console.log("test",this.nn.AD_Role_ID)
            console.log(JSON.parse(localStorage.getItem('testjwt')))
            var base64Url = JSON.parse(localStorage.getItem('testjwt')).split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            console.log("token details :",JSON.parse(jsonPayload));
            const payload ={"login" : { "AD_Role_ID" : this.nn.AD_Role_ID}}
            console.log("input",JSON.stringify(payload))
            getOrg(payload).then(response => {
              console.log("jwt :",response);

              if (response.jwt) {
                var base64Url = response.jwt.split('.')[1];
                var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                  return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));

                this.logindetails= JSON.parse(jsonPayload);
                console.log(this.logindetails);
                localStorage.setItem('AD_Client_ID', JSON.stringify(this.logindetails.AD_Client_ID));
                localStorage.setItem('AD_Org_ID', JSON.stringify(this.logindetails.AD_Org_ID));
                localStorage.setItem('AD_Role_ID', JSON.stringify(this.logindetails.AD_Role_ID));
                localStorage.setItem('AD_Session_ID', JSON.stringify(this.logindetails.AD_Session_ID));
                localStorage.setItem('AD_User_ID', JSON.stringify(this.logindetails.AD_User_ID));
                localStorage.setItem('AD_Warehouse_ID', JSON.stringify(this.logindetails.AD_Warehouse_ID));
                localStorage.setItem('Name', JSON.stringify(this.logindetails.Name));


              }

              else {
                this.flashMessage.error({title: 'Error ', message: response.message});
              }

            });
          }
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/page/Login1.vue